import { Injectable, Type } from '@angular/core';
import { GeneralModalComponent } from '../../../modals/general-modal/general-modal.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',

})
export class ModalNotificationService {

  constructor(private dialog: MatDialog) { }


  openModal(data: any) {
    return this.dialog.open(GeneralModalComponent, { data: data })
  }

  openCreateEditModal<T>(component: Type<T>, data?: any): MatDialogRef<T> {
    return this.dialog.open(component, {
      data: data,
      width: data?.modalWidth ?? undefined,
      panelClass: data?.modalWidth ? 'modal-wide-panel' : undefined,
    });
  }

  closeModal() {
    this.dialog.closeAll()
  }
}
